import { Check } from '@mui/icons-material';
import { Box, Button, CircularProgress, Container } from '@mui/material';
import { Subheader } from 'components';
import InPersonEventForm from './InPersonEventForm';
import {
	useAlerts,
	useInPersonEvents,
	useTimezones,
	useUploadFileInMemory
} from 'hooks';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { validateInPersonEvent } from 'validations/events';
import { isArray } from 'lodash';

export default function InPersonEventEdit() {
	const { id } = useParams();
	const navigate = useNavigate();

	const {
		inPersonEvent,
		fetchInPersonEvent,
		isLoading,
		handleChange,
		updateInPersonEventResource,
		updateInPersonEvent
	} = useInPersonEvents();
	const { memoryFile, removeFile, handleUploadFile } = useUploadFileInMemory();

	const { showAlertError, showAlertSuccess } = useAlerts();

	const handleSaveClick = async () => {
		const valid = validateInPersonEvent(inPersonEvent);

		if (!valid.isValid) {
			showAlertError(valid.messages[0]);
			return;
		}

		if (!memoryFile && !inPersonEvent.image_url) {
			showAlertError('Event Image is required');
			return;
		}

		const response = await updateInPersonEvent(inPersonEvent, memoryFile);

		if (response && response.status && response.status !== 200) {
			const error = response?.data?.error;
			const defaultMessage = 'Fail to update, try again';

			if (isArray(error)) {
				showAlertError(response?.data?.error[0] || defaultMessage);
			} else {
				showAlertError(response?.data?.error || defaultMessage);
			}

			return;
		}
		showAlertSuccess('In-Person Event updated');

		navigate(-1);
	};

	const handleUpload = async (file, type) => {
		await handleUploadFile(file, type);
	};

	const handleDelete = async () => {
		await removeFile();
		updateInPersonEventResource((prev) => ({ ...prev, image_url: '' }));
	};

	useEffect(() => {
		fetchInPersonEvent(id);
	}, [id]);

	return (
		<div>
			<Subheader
				title={'drmo'}
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={isLoading ? <CircularProgress size={18} /> : <Check />}
						onClick={handleSaveClick}
						disabled={isLoading}
					>
						Update In-Person Event
					</Button>
				]}
			/>
			<Container>
				<Box p={4}>
					<InPersonEventForm
						inPersonEvent={inPersonEvent}
						handleChange={handleChange}
						memoryFile={memoryFile}
						handleDelete={handleDelete}
						handleUpload={handleUpload}
					/>
				</Box>
			</Container>
		</div>
	);
}
